import LoadingSpinner from '@/components/ui/LoadingSpinner';
import { useAuth } from '@/contexts/AuthContext';
import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated, isLoading, devTokenError, user } = useAuth();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <LoadingSpinner size="lg" text="Loading..." />
      </div>
    );
  }

  // Dev-token failure: show actionable error instead of silently redirecting to login
  if (devTokenError) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-app-gradient px-4">
        <div className="glass-panel p-8 max-w-lg text-center">
          <h1 className="text-xl font-bold text-white mb-3">Dev Token Failed</h1>
          <p className="text-sm text-gray-400 mb-4">{devTokenError}</p>
          <p className="text-xs text-gray-500">
            Check that <code className="text-brand-400">VITE_GATEWAY_URL</code> in{' '}
            <code className="text-brand-400">.env.local</code> points to a running gateway,
            then restart the dev server.
          </p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // CASA 1.1.2: an admin-set initial password must be replaced before
  // anything else; the gateway refuses every other call until it is.
  if (user?.password_change_required) {
    return <Navigate to="/change-password" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
